import ContactForm from '@/components/ContactForm'
import EntryHeader from '@/components/EntryHeader'
import FlexibleContent from '@/components/FlexibleContent'
import LeadershipGrid from '@/components/LeadershipGrid'
import Main from '@/components/Main'
import Posts from '@/components/Posts'
import SEO from '@/components/SEO'

export default function Component(props) {
  // Loading state for previews
  if (props.loading) {
    return null
  }

  const page = props?.data?.page
  const metaDesc = page?.seo?.metaDesc
  const { title, featuredImage } = page ?? { title: '' }
  const flexibleContent = page?.template?.flexibleContent?.flexibleContentFields ?? []
  const form = props?.data?.contactForm
  const headerForm = props?.data?.headerForm
  const seoTitle = page?.seo?.title

  // The leaders are this page's child pages. Nothing here has to be kept in sync by
  // hand: publishing a child page under /leadership/ adds a card.
  const leaders = page?.children?.nodes ?? []

  return (
    <>
      <SEO title={seoTitle || title} description={metaDesc} imageUrl={featuredImage?.node?.sourceUrl} />

      <EntryHeader pageFields={page} image={featuredImage?.node} form={headerForm} title={title} />

      <Main>
        {/*
          The eyebrow, heading and intro copy come from the page's own Content Block.
          `centered` is the light-background treatment: the default is styled for a dark
          background and renders its subheading in white.
        */}
        <FlexibleContent content={flexibleContent} contentBlockProps={{ variant: 'centered', headingLevel: 2 }} />

        <LeadershipGrid leaders={leaders} />

        <section data-aos="fade-up">
          <Posts posts={props?.data?.posts?.nodes} id="posts-list" />
        </section>
      </Main>

      {form && <ContactForm form={form} />}
    </>
  )
}
